<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ isEditMode ? "Editar Registro" : "Nuevo Registro" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
    <!-- Día -->
    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Día</mat-label>
      <mat-select
        [(ngModel)]="currentBusinessPartnerSchedule.day"
        name="day"
        required
      >
        <mat-option *ngFor="let day of daysList" [value]="day.value">{{
          day.day
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Hora de Inicio -->
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Hora de Inicio</mat-label>
      <input
        matInput
        type="time"
        [(ngModel)]="currentBusinessPartnerSchedule.hourStart"
        name="hourStart"
        required
      />
    </mat-form-field>

    <!-- Hora de Fin -->
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Hora de Fin</mat-label>
      <input
        matInput
        type="time"
        [(ngModel)]="currentBusinessPartnerSchedule.hourEnd"
        name="hourEnd"
        required
      />
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
    {{ isEditMode ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>
